import axios from 'axios'
import { Message, Notification } from 'element-ui'
import store from '@/store'
import router from '@/router'
import { getToken, getTenant } from '@/utils/auth'
import networkState, { markDisconnected, markConnected } from '@/utils/network'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 60000 * 10
})

// request interceptor
service.interceptors.request.use(
  config => {
    const tenantId = getTenant();
    if (tenantId) {
      config.headers['tenant-id'] = tenantId;
    }
    if (store.getters.token) {
      config.headers['X-Access-Token'] = store.getters.token;
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

let networkNotify = null

function showNetworkDisconnected() {
  if (networkNotify) return
  if (!store.getters.token) return
  markDisconnected()
  networkNotify = Notification({
    title: '网络连接已断开',
    message: '无法连接到服务器，请检查网络后重试',
    type: 'error',
    duration: 0,
    position: 'bottom-right',
    customClass: 'network-disconnect-notify'
  })
}

function dismissNetworkNotify() {
  if (networkNotify) {
    networkNotify.close()
    networkNotify = null
  }
}

// response interceptor
service.interceptors.response.use(
  response => {
    const res = response.data

    if (res.code === 401) {
      store.dispatch('user/clearInfo').then(() => {
        router.push('login');
        return Promise.reject(res)
      })
    } else if (res.success == false) {
      Message({
        message: res.message || 'Error',
        type: 'error',
        duration: 5 * 1000
      })
      Promise.reject(res).catch(()=>{
      })
      return res
    } else {
      if (!networkState.serverReachable) {
        markConnected()
        dismissNetworkNotify()
        Message({
          message: '网络已恢复连接',
          type: 'success',
          duration: 3 * 1000
        })
      }
      return res
    }
  },
  error => {
    console.log('requrest error' , error)

    if (error.response) {
      dismissNetworkNotify()
      markConnected()
      switch (error.response.status) {
        case 401:
            store.dispatch('user/clearInfo').then(() => {
              router.push('login');
            })
            break;
            default:
              if(error.response.data && error.response.data.message){

                if(error.response.data.message == "商户信息未指定，认证失败"){
                  store.dispatch('user/clearInfo').then(() => {
                    router.push('login');
                  })
                }else{
                  Message({
                    message: error.response.data.message || 'Error',
                    type: 'error',
                    duration: 5 * 1000
                  });
                }
              }
              Message({
                message: error.response.message || 'Error',
                type: 'error',
                duration: 5 * 1000
              });
          }

    } else if (error.message === 'Network Error' || error.code === 'ECONNABORTED') {
      showNetworkDisconnected()
    } else {
      Message({
        message: error.message || 'Error',
        type: 'error',
        duration: 5 * 1000
      })
    }

    return Promise.reject(error)
  }
)

export default service
